import { API_URLS } from "../constants";
import apiClient from "./interceptor";
import inferenceClient from "./inferenceInterceptor"
import { encryptAES } from './crypto';
const inferenceUrl = process.env.REACT_APP_INFERENCE_URL;

export const login = async (loginParams) => {
    try {
        const secretKey = process.env.REACT_APP_SECRET_KEY || "";
        const encryptedData = await encryptAES(loginParams.password, secretKey);
        const loginPayloadParams = {
            user_name: loginParams.user_name,
            iv_hex: encryptedData.iv,
            encrypted_hex: encryptedData.encrypted,
        };

        const response = await apiClient.post(API_URLS.AUTH.LOGIN, loginPayloadParams);
        return response.data;
    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
};

export const changePassword = async (changePasswordParams) => {
    try {
        const secretKey = process.env.REACT_APP_SECRET_KEY || "";
        const oldEncryptedData = await encryptAES(changePasswordParams.old_password, secretKey);

        const changePasswordPayloadParams = {
            user_name: changePasswordParams.user_name,
            iv_hex_old: oldEncryptedData.iv,
            encrypted_hex_old: oldEncryptedData.encrypted,
            new_password: changePasswordParams.new_password,
        };

        const response = await apiClient.post(
            API_URLS.AUTH.CHANGE_PASSWORD,
            changePasswordPayloadParams,
            {
                headers: changePasswordParams.token
                    ? { Authorization: `Bearer ${changePasswordParams.token}` }
                    : {},
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error changing password:", error);
        throw error;
    }
};

export const getCropsAndVarieties = async (company_id) => {
    try {
        const response = await apiClient.get(`${API_URLS.CROP_VARIETY_MACHINE.GET_CROPS_AND_VARIETIES}/${company_id}`);
        return response
    } catch (error) {
        console.log(error);
    }
}

// get all machine
export const getAllMachine = async (company_id) => {
    try {
        const response = await apiClient.get(`${API_URLS.CROP_VARIETY_MACHINE.GET_MACHINES}/${company_id}`);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getUserScanHistory = async (user_id, limit = 10, offset = 0) => {
    try {
        const response = await apiClient.get(`${API_URLS.SCAN.GET_USER_SCAN_HISTORY}/${user_id}?limit=${limit}&offset=${offset}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching user scan history:", error);
        throw error;
    }
};

export const getScanPdf = async (scanId) => {
    try {
        const payload = { "scan_id": scanId };
        const response = await apiClient.post(
            API_URLS.SCAN.GET_SCAN_PDF,
            payload,
            { responseType: 'blob' }
        );

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${scanId}.pdf`;
        link.click();

        URL.revokeObjectURL(blobUrl);
        return response;
    } catch (error) {
        console.error(error);
        return error
    }
};

export const getUpdatedScanPdf = async (scanId) => {
    try {
        const payload = { "scan_id": scanId };
        const response = await apiClient.post(
            API_URLS.SCAN.GET_UPDATED_SCAN_PDF,
            payload,
            { responseType: 'blob' }
        );

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${scanId}.pdf`;
        link.click();

        URL.revokeObjectURL(blobUrl);
        return response;
    } catch (error) {
        console.error(error);
        return error
    }
};

export const getRequestConfigurations = async (crop_id, machine_code) => {
    try {
        const response = await apiClient.post(`${API_URLS.CROP.REQUEST_CONFIGURATIONS}`, {
            crop_id,
            machine_code,
        });
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const getCompanyMetaData = async (company_id) => {
    try {
        const response = await apiClient.post(`${API_URLS.METADATA.GET_METADATA_BY_COMPANY_ID}/${company_id}`);
        return response
    } catch (error) {
        console.error(error);
    }
}

export const postScanMetaData = async (scan_id, sub_scan_id, scanMetaData) => {
    try {
        const response = await apiClient.post(`${API_URLS.SCAN.POST_SCAN_METADATA}`, {
            scan_id,
            sub_scan_id,
            scan_metadata: scanMetaData,
        });
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const postScanFiles = async (scan_id, sub_scan_id, fileArray) => {
    try {
        const formData = new FormData();
        formData.append("scan_id", scan_id);
        formData.append("sub_scan_id", sub_scan_id);

        fileArray.forEach((itemFile) => {
            formData.append("file", itemFile, itemFile.name);
        });

        const response = await apiClient.post(
            `${API_URLS.SCAN.POST_SCAN_FILES}`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            }
        );

        return response;
    } catch (error) {
        console.error("Error uploading scan files:", error);
        throw error;
    }
};


export const postCvScanResult = async (scan_id, sub_scan_id, scan_result) => {
    try {
        const response = await apiClient.post(`${API_URLS.SCAN.POST_SCAN_RESULT}`, {
            scan_id,
            sub_scan_id,
            scan_result,
        });
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const AddCustomVarietes = async (crop_id, company_id, variety_name) => {
    try {
        const response = await apiClient.post(`${API_URLS.CROP_VARIETY_MACHINE.ADD_CUSTOM_VARIETY}`, {
            crop_id,
            company_id,
            variety_name,
        });
        return response;
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const sendInferenceRequest = async ({
    image,
    image_bottom,
    shadow_image,
    shadow_bottom_image,
    machineType,
    cropType,
    companyId,
    moistureValue,
    weightValue,
    locationId,
    scanId,
    subScanId,
    cropID,
    machineID,
    machineInstanceId,
    varietyID,
    user_id,
    variety_code,
    updatedUserMetaData,
    reqConfigValues,
    processed_variety_name,
    coin_radius,
    coin_radius_bottom
}) => {
    try {

        const formData = new FormData();

        formData.append("image", image, image.name);
        if (image_bottom) {
            formData.append("bottom_image", image_bottom, image_bottom.name);
        }
        if (shadow_image) {
            formData.append("shadow_image", shadow_image, shadow_image.name);
        }
        if (shadow_bottom_image) {
            formData.append("shadow_bottom_image", shadow_bottom_image, shadow_bottom_image.name);
        }

        if (machineType === 'M4' && shadow_image && shadow_bottom_image) {
            formData.append("coin_type", "0");
            formData.append("coin_radius_top", "285");
            formData.append("coin_radius_bottom", "285");
            // formData.append("coin_type", String(0));
            // formData.append("coin_radius_top", String(coin_radius));
            // formData.append("coin_radius_bottom", String(coin_radius_bottom));
        }
        //  else {
        //     formData.append("coin_type", String(1));
        //     formData.append("coin_radius", String(coin_radius));
        // }

        formData.append("machine_type", machineType);
        formData.append("crop_type", cropType);
        formData.append("company_id", companyId);
        formData.append("build_code", "v1.0.0");
        formData.append("device_info", "Browser");
        formData.append("build_version", "1.0.0");
        formData.append("location_id", locationId);
        formData.append("build_type", "DEV");
        formData.append("user_metadata", JSON.stringify(updatedUserMetaData));
        formData.append("moisture_value", moistureValue);
        formData.append("weight_value", weightValue);
        formData.append("req_config_values", JSON.stringify(reqConfigValues));

        if (variety_code) {
            formData.append("crop_variety", variety_code);
        }
        if (processed_variety_name) {
            formData.append("crop_variety_name", processed_variety_name);
        }

        const headers = {
            "Upjao-Scan-ID": scanId,
            "Upjao-Sub-Scan-ID": subScanId,
            "Company-ID": companyId,
            "Crop-ID": cropID,
            "Machine-ID": machineID,
            "Variety-ID": varietyID,
            "User-ID": user_id,
            "Machine-Instance-ID": machineInstanceId
        };

        const response = await inferenceClient.post(`${inferenceUrl}`, formData, {
            headers,
        });
        return response;
    } catch (error) {
        console.error("Inference request failed:", error);
        throw error;
    }
};

